<template>
	<div class="w-100">
		<div v-if="redirecting">
			<div class="d-flex align-items-center border border-success rounded p-2 gap-2">
				<i class="bi bi-arrow-up-right-circle-fill text-info fs-1"></i>
				<p class="ms-2">
					<strong class="text-info font-bold text-uppercase">Redirecting...</strong>
					<span class="d-block">Finding you parts that fit your vehicle</span>
				</p>
			</div>
		</div>
		<div v-else>
		<div v-if="isUniversal">
			<!-- <div class="d-flex align-items-center border border-success rounded p-2 gap-2">
				<i class="bi bi-check-circle-fill text-success fs-1"></i>
				<p class="ms-2">
					<strong class="text-success font-bold text-uppercase">Universal Fit</strong>
					<span class="d-block"> This product is not vehicle specific</span>
				</p>
			</div> -->
		</div>

		<div v-else>
			<button class="btn btn-secondary w-100" v-if="make_id == null" @click="openVehicleModal">
				<strong> Will it fit? </strong>
				Check your vehicle <i class="bi bi-chevron-double-right"></i>
			</button>
			<div v-else-if="make_id != null">
				<div v-if="doesItFit">
					<div class="d-flex align-items-center border border-success rounded p-2 gap-2">
						<i class="bi bi-check-circle-fill text-success fs-1"></i>
						<p class="ms-2">
							<strong class="text-success font-bold text-uppercase">Will fit Selected Vehicle</strong>
							<span class="d-block">{{ year }} {{ make_name }} {{ model_name }}</span>
						</p>
					</div>
				</div>
				<div v-else>
					<div class="d-flex align-items-center border border-danger rounded p-2 gap-2">
						<i class="bi bi-x-circle-fill text-danger fs-1"></i>
						<p class="ms-2">
							<strong class="text-danger font-bold text-uppercase">Won't fit Selected Vehicle</strong>
							<span class="d-block">{{ year }} {{ make_name }} {{ model_name }}</span>
							<a :href="redirectUrl"  class="btn btn-sm btn-info mt-2">
								<strong>See similar parts that do fit</strong>
								<i class="bi bi-chevron-right"></i>

							</a>
						</p>
					</div>
				</div>
				<div class=" d-flex justify-content-center">
						<button class="btn text-info" @click="openVehicleModal">Update or Change Vehicle <i
								class="bi bi-chevron-double-right"></i></button>
					</div>
				</div>
			</div>
		</div>
		<VehicleModal ref="vehicleModal" @vehicle-selected="onVehicleSelected" />
	</div>
</template>

<script>
import VehicleModal from '../Vehicle/VehicleModal.vue';
export default {
	name: 'FitmentCheck',
	components: {
		VehicleModal,
	},
	data() {
		return {
			make_id: null,
			model_id: null,
			year: 2024,
			make_name: '',
			model_name: '',
			fitments: [],
			doesItFit: false,
			product_id: null,
			manufacturer_id: null,
			redirecting: false,
		};
	},

	mounted() {
		if (window.vrdata) {
			this.fitments = window.vrdata.product.fitment;
			if (window.vrdata?.vehicle?.model_id != 0) {
				this.make_id = window.vrdata.vehicle.make_id;
				this.model_id = window.vrdata.vehicle.model_id;
				this.year = window.vrdata.vehicle.year;
				this.make_name = window.vrdata.vehicle.make_name;
				this.model_name = window.vrdata.vehicle.model_name;
			}
			this.product_id = window.vrdata.product.id;
			this.category_id = window.vrdata.product.category_id;
			this.manufacturer_id = window.vrdata.product.manufacturer_id;

			this.doesItFit = this.checkFitment();
		}
	},

	methods: {
		checkFitment() {
			let doesItFit = false;


			let fitments = Object.values(this.fitments);
			if (fitments.length > 0) {
				fitments.forEach(fitment => {
					if (fitment.model_id == this.model_id && fitment.make_id == this.make_id && parseInt(fitment.year) == parseInt(this.year)) {
						doesItFit = true;
					}
				});
			}
			return doesItFit;
		},

		openVehicleModal() {
			console.log(this.$refs.vehicleModal);
			this.$refs.vehicleModal.showModal();
		},
		onVehicleSelected(selectedVehicle) {
			console.log('Selected vehicle:', selectedVehicle);
			this.make_id = selectedVehicle.make_id;
			this.model_id = selectedVehicle.model_id;
			this.year = selectedVehicle.year;
			this.make_name = selectedVehicle.make_name;
			this.model_name = selectedVehicle.model_name;

			this.doesItFit = this.checkFitment();

		},
	},

	computed: {
		isUniversal() {
			return this.fitments.length == 0 || this.fitments == null;
		},

		redirectUrl() {
			return `/fitment_redirect.php?products_id=${this.product_id}&category_id=${this.category_id}&manufacturer_id=${this.manufacturer_id}`;
		},
	},


};
</script>
